import { render } from "./PolstermaterialPage.vue?vue&type=template&id=a002b446"
import script from "./PolstermaterialPage.vue?vue&type=script&lang=js"
export * from "./PolstermaterialPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__